import React from "react";

/**
 * Door Refinishing icon — a front door with an upper-half window + three lower
 * panels. The `.bdrv2-ico-door-panel` group swings open on tile hover (see
 * serviceIcons.css). Plain SVG — edit the paths freely; uses currentColor so it
 * matches the theme accent.
 */
const ServiceDoorIcon = () => (
  <svg
    className="bdrv2-svc-ico bdrv2-ico-door"
    viewBox="0 0 48 48"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {/* floor line + door frame (stays put) */}
    <path d="M8 43 H40" />
    <path d="M12 5 H36 V43 H12 Z" />

    {/* the opening door slab (hinged on the left) */}
    <g className="bdrv2-ico-door-panel">
      <path d="M14 7 H34 V43 H14 Z" />
      {/* upper-half window with mullions */}
      <rect x="17" y="10" width="14" height="13" rx="1" />
      <path d="M24 10 V23 M17 16.5 H31" />
      {/* three lower panels */}
      <rect x="17" y="26" width="14" height="4.5" rx="1" />
      <rect x="17" y="31.5" width="14" height="4.5" rx="1" />
      <rect x="17" y="37" width="14" height="4.2" rx="1" />
      {/* knob */}
      <circle cx="31" cy="24.5" r="1.2" fill="currentColor" stroke="none" />
    </g>
  </svg>
);

export default ServiceDoorIcon;
